module.exports = {"apiKey":"AIzaSyDcSogGIbUv7vJ0dYmd2M4bRAV9F2ZZGpk","authDomain":"fosol-dev.firebaseapp.com","databaseURL":"https://fosol-dev.firebaseio.com","projectId":"fosol-dev","storageBucket":"fosol-dev.appspot.com","messagingSenderId":"329049115794","API_URL":"https://us-central1-fosol-dev.cloudfunctions.net/api/v0/","CDN_URL":"https://firebasestorage.googleapis.com/v0/b/fosol-dev.appspot.com/o/","fav_icon":"./images/android_icon_dev.png"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/config.json
// module id = 474
// module chunks = 0